import request from '@/utils/request'
export default {  
    getYears(data) {
        // 时间轴
        return request({
            url: '/dp/years',
            method: 'get', 
        })
    },   
    getDzYears(data) {
        //  地震灾害时间轴
        return request({
            url: '/dp/dzYears',
            method: 'get', 
        })
    }, 
    getFzYears(data) {
        //  防灾减灾时间轴
        return request({
            url: '/dp/fzYears',
            method: 'get', 
        })
    }, 
    getSjYears(data) {
        //  社会经济时间轴
        return request({
            url: '/dp/sjYears',
            method: 'get', 
        })
    },  
    seriesCoreLabel(data) {
        // 获取核心指标
        return request({
            url: '/db/seriesCoreLabel',
            method: 'post',
            data
        })
    },
    coreLabelData(data) {
        // 获取核心指标
        return request({
            url: '/dp/coreLabelData',
            method: 'post',
            data
        })
    }, 
    eqLeftOne(data) {
        // 获取观测点数据
        return request({
            url: '/dp/eqLeftOne',
            method: 'post',
            data
        })
    },
    eqLeftTwo(data) {
        // 获取地震台数数据
        return request({
            url: '/dp/eqLeftTwo',
            method: 'post',
            data
        })
    },eqRightOne(data) {
        // 获取灾害统计数据
        return request({
            url: '/dp/eqRightOne',
            method: 'post',
            data
        })
    }, eqRightTwo(data) {
        // 获取灾害次数统计数据
        return request({
            url: '/dp/eqRightTwo',
            method: 'post',
            data
        })
    },  
    dpLeftOne(data) {
        // 获取水资源情况数据
        return request({
            url: '/dp/dpLeftOne',
            method: 'post',
            data
        })
    },    dpLeftTwo(data) {
        // 获取主要河流情况数据 
        return request({
            url: '/dp/dpLeftTwo',
            method: 'post',
            data
        })
    },  
    dpLeftThree(data) {
        // 获取主要城市气象数据 
        return request({
            url: '/dp/dpLeftThree',
            method: 'post',
            data
        })
    },  
    dpRightOne(data) {
        // 获取地址灾害数据 
        return request({
            url: '/dp/dpRightOne',
            method: 'post',
            data
        })
    },  
     
    dpRightTwo(data) {
        // 获取草原灾害数据 
        return request({
            url: '/dp/dpRightTwo',
            method: 'post',
            data
        })
    },  
    dpRightThree(data) {
        // 获取森林虫害数据 
        return request({
            url: '/dp/dpRightThree',
            method: 'post',
            data
        })
    },   
    seLeftOne(data) {
        // 获取国民经济核算数据 
        return request({
            url: '/dp/seLeftOne',
            method: 'post',
            data
        })
    },  
    seLeftTwo(data) {
        // 获取国民财政收支数据 
        return request({
            url: '/dp/seLeftTwo',
            method: 'post',
            data
        })
    },   seLeftThree(data) {
        // 获取各行业产值数据 
        return request({
            url: '/dp/seLeftThree',
            method: 'post',
            data
        })
    },
    seRightOne(data) {
        // 获取消费价格指数数据 
        return request({
            url: '/dp/seRightOne',
            method: 'post',
            data
        })
    }, seRightTwo(data) {
        // 获取零售价格指数数据 
        return request({
            url: '/dp/seRightTwo',
            method: 'post',
            data
        })
    }, seRightThree(data) {
        //  获取产业增加值指数数据  
        return request({
            url: '/dp/seRightThree',
            method: 'post',
            data
        })
    }, 
   
 
}


// WEBPACK FOOTER //
// ./src/api/dataScreen.js